import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { Button, Checkbox, Spin, Form, DatePicker, Input, Select, Row, Col } from 'antd';
import moment from 'moment';//日期格式化导包

import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import Message from '../../component/message/message';//提示信息弹框
import { Base } from '../../public/js/base';
import context from '../../public/js/context';
import './changeUserPassword.css';

const { Option } = Select;

const ChangeUserPassword = (props) => {

    const history = useHistory();
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [oldModel, setOldModel] = useState({});

    useEffect(() => {
        searchUserInfoByCode();
    }, []);

    /**查詢用戶信息列表 方法 */
    const searchUserInfoByCode = () => {
        setIsLoad(true);
        setSpinInfo("Searching...");
        Base.callBackApi("user/searchUserInfoById", { userId: Config.userInfo.userId }).then((data) => {
            if ("SUCCESS" === data.msg) {
                initForm(data.object);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            userId: model.userId ?? '',
            userName: model.userName ?? '',
        });
        setOldModel(model);
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo("Data is processing...")
        let model = { ...oldModel, ...values };
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("user/changePwd", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                initForm(data.object);
                errFrameShow("success", "Saved successfully.");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        history.push('/main/default');
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const validatePassword = async (_, value) => {
        if (!value) {
            throw new Error("New Password is required.");
        }
        // 密码长度至少为8位
        if (value.length < 8) {
            throw new Error("The New Password must have at least 8 digits.");
        }
        // 密码需要包含大写字母、小写字母、数字和特殊字符
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[()`!@#$%^&*_\-+=|{}[\]:;'<>,.?])[A-Za-z\d()`!@#$%^&*_\-+=|{}[\]:;'<>,.?]+$/;
        if (!passwordRegex.test(value)) {
            throw new Error("The New Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character.");
        }
        return Promise.resolve();
    };

    return (
        <div id="container" className="container">
            <div className='changeUserPassword'>
                <div className="sysModelTitle">Change Password</div>
                {/* 错误信息弹框 */}
                <Message ref={messageRef} />
                <div className='templateMain'>
                    <Spin size="large" spinning={isLoad} tip={spinInfo}>
                        <Form form={form} onFinish={onFinish}>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysParam mustFill">Old Password</div>
                                    <div className="sysInput">
                                        <Form.Item
                                            name="oldPwd"
                                            rules={[
                                                { required: true, message: 'Old Password is required.' }
                                            ]}
                                        >
                                            <Input type="password" placeholder="Old Password" maxLength={100} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysParam mustFill">New Password</div>
                                    <div className="sysInput">
                                        <Form.Item
                                            name="newPwd"
                                            dependencies={['oldPwd']}
                                            rules={[
                                                { validator: validatePassword },
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        if (Base.isNotEmpty(getFieldValue('oldPwd')) && Base.isNotEmpty(value) && value.length >= 8) {
                                                            if (getFieldValue('oldPwd') === value) {
                                                                return Promise.reject(new Error('The New Password is consistent with the Old Password'));
                                                            }
                                                        }
                                                        return Promise.resolve();
                                                    },
                                                }),
                                            ]}
                                        >
                                            <Input type="password" placeholder="New Password" maxLength={100} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysParam mustFill">New Password(Comfirm)</div>
                                    <div className="sysInput">
                                        <Form.Item
                                            name="pwd"
                                            dependencies={['newPwd']}
                                            rules={[
                                                { required: true, message: 'New Password(Comfirm) is required.' },
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        if (!value || getFieldValue('newPwd') === value) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(new Error('The New Password is not consistent with the New Password(Comfirm).'));
                                                    },
                                                }),
                                            ]}
                                        >
                                            <Input type="password" placeholder="New Password(Comfirm)" maxLength={100} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='sysSearchButton'>
                                <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit" >Save</Button>
                                <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>Cancel</Button>
                            </div>
                        </Form>
                    </Spin>
                </div>
            </div>
        </div>
    )

}

export default ChangeUserPassword;